import { DEFAULT_LOCALE } from 'Types/globals';
import { LANGUAGES_BY_COUNTRY } from './languages';
import { countryDefaultLanguage } from './variables';

const isLocaleAvailable = locale => {
  const supportedLocales = process.env.SUPPORTED_LOCALES;

  if (!supportedLocales) return false;

  const locales = supportedLocales.split(',');

  return locales.includes(locale);
};

export const getTargetLocale = ({
  country,
  preferredLocale,
  defaultLocale = DEFAULT_LOCALE,
}: {
  country: string;
  preferredLocale: string;
  defaultLocale: string;
}) => {
  const selectedCountry = country;
  let countryDefaultLocale = countryDefaultLanguage[selectedCountry];

  if (LANGUAGES_BY_COUNTRY[country]) {
    /** Remove preferredLocale if the geo-location was changed to another one where the current preferredLocale is not available. */
    if (!LANGUAGES_BY_COUNTRY[country]?.test(preferredLocale)) preferredLocale = countryDefaultLocale;
  } else {
    preferredLocale = defaultLocale;
  }

  let targetLocale = preferredLocale ?? countryDefaultLocale ?? defaultLocale;
  // If new country locale is not supported
  if (!isLocaleAvailable(countryDefaultLocale)) {
    countryDefaultLocale = defaultLocale;
  }

  // If user changes its VPN and preferred local is not available anymore
  if (!isLocaleAvailable(targetLocale)) {
    targetLocale = countryDefaultLocale ?? defaultLocale;
  }

  return targetLocale;
};
